import React from "react";
import DueStudents from "../../components/DueStudents";
import Layout from "../../components/shared/Layout/Layout";

const DueStudentsPage = () => {
  return (
    <div
      className="bg_dark"
      style={{ minHeight: "100vh", position: "relative" }}
    >
      <Layout title="Due Students">
        <DueStudents />
      </Layout>
    </div>
  );
};

export default DueStudentsPage;
